import { get, post } from '@/utils/http.js'

//获取时间
export const getTime = () => get('https://quan.suning.com/getSysTime.do');

//获取天气
export const getWeather = (data) => get('https://restapi.amap.com/v3/weather/weatherInfo', data);

//获取菜单
export const getMenu = (data) => get('/menu/thisusermenu', data);

//登录
export const login = (data) => post('/user/login', data);

//登出
export const logout = (data) => get('/user/logout', data);

//获取地区
export const getArea = (data) => get('/tr_api/v1/area/area-all', data);

//获取字典表
export const getMap = (data) => post('/tr_api/v1/map/list-map', data);

//id获取字典表
export const getMapByid = (id) => post('/devicemanage/mapcode', { mc_parent_id: id });
// 是否维护

export const getWeihu = () => post('/role/detailmaintain');

export const getAreaNew = () => get('/trmonitor/area/FatherSonLinkageList?threeLevel=4')

// export function getAreaNew(params){
//     return get({})
// }
